import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles, GenericFormSection } from "models/propTypes/genericFormProps";
import { FilterFormProps } from "models/propTypes/filterPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { FilterFormTypes } from "models/formTypes";
//#endregion
//#region components
import GenericForm from "../../forms/genericForm";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const FilterForm: ForwardRefRenderFunction<FormHandles, FilterFormProps> = (props, ref) => {
  const { savedFilters, filterCategory, onQuickSelectionChange } = props;

  const filterSelection: GenericFormSection<FilterFormTypes.FilterBase>[] = [
    {
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      label: TranslationKeys.Filter.SavedFilters,
      icon: IconDefinitionConstants.WSave,
      extraProps: {
        summaryType: FormEnums.ExpandableFormSummaryType.SELECTEDCOUNT,
      },
      hidden: filterCategory === undefined || savedFilters === undefined || savedFilters.length === 0,
      innerFields: {
        selectedFilter: {
          label: "",
          type: FormEnums.FormFieldType.SELECTION,
          extraProps: {
            items: savedFilters.map((f) => ({
              id: f.id,
              value: `${f.name ?? "???"}${
                f.isDefault
                  ? ` (${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Default).toLowerCase()})`
                  : ""
              }`,
            })),
          },
          onChangeHandler: onQuickSelectionChange,
        },
      },
    },
  ];

  const filterFields = Array.isArray(props.fields)
    ? props.fields.map(
        (f): GenericFormSection<any> =>
          f.type === FormEnums.FormSectionType.EXPANDABLESECTION
            ? {
                ...f,
                extraProps: {
                  ...(f.extraProps ?? {}),
                  summaryType: FormEnums.ExpandableFormSummaryType.SELECTEDCOUNT,
                  initiallyOpen: true,
                },
              }
            : f
      )
    : [
        {
          type: FormEnums.FormSectionType.EXPANDABLESECTION,
          label: "",
          extraProps: {
            alwaysOpen: true,
          },
          innerFields: props.fields,
        },
      ];

  const fields: GenericFormSection<any>[] = filterSelection.concat(filterFields);

  return (
    <GenericForm
      formRef={ref}
      defaultValues={props.defaultValues}
      fields={fields}
      hideSuccess
      hideErrorBubble
      enableControlLables
      formGridLayout={{ message: false }}
      hideOptionalIndicator
      validationSchema={props.validationSchema}
    />
  );
};

export default forwardRef(FilterForm);
